import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles(()=>({
    icon: {
        color: 'black',
        backgroundColor: 'white',
        width: 18,
        height: 18
    },
    root: {
        position: "relative",
        padding: 0,
        overflow: 'visible',
        fontSize: '1.5rem',
        textAlign: 'center',
        borderRadius: 0,
        backgroundColor: 'inherit',
        clear: 'both',
        '&:hover': {
            backgroundColor: 'inherit'
        }
    }
}))

export const DeleteButtonTextField = ({onClick, disabled, hidden, style}) => {
    const classes = useStyles()
    if (hidden) return null
    return <IconButton onClick={onClick}
                       disabled={disabled}
                       label={'Удалить'}
                       classes={{root: classes.root}}
                       disableFocusRipple
                       disableRipple
                       disableTouchRipple
                       style={style || {
                           left: 'calc(100% - 9px)',
                           bottom: 'calc(100% - 9px)'
                       }}
    >
        <CancelIcon className={classes.icon}/>
    </IconButton>
}